//@ts-ignore
import { v4 as uuidv4 } from 'uuid';
import { createLayer, removeLayer, setLayerSettings, setLayerVisible } from '../store/actions';
import { state } from '../store/state';

import type { Layer } from '../layers';

export interface MapTemplate {
    id: string;
    title: string;
    author: string;
    dateCreate: Date;
    changedBy: string;
    lastChange: Date;
    data: LayerTemplateData[];
}

export interface LayerTemplateData {
    layer: Layer;
    visibility: boolean;
    settings?: Record<string, unknown>;
}

export function clearLayers() {
    Array.from(state.layerStructure.values()).forEach(layer => removeLayer(layer));
}

// временные, для отладки, сохраняют и загружают в/из state
export function saveCurrentTemplate(title: string) {
    const result = {
        id: uuidv4(),
        title: title,
        author: 'skorskin.ss',
        dateCreate: new Date(),
        changedBy: 'skorskin.ss',
        lastChange: new Date(),
        data: new Array<LayerTemplateData>(),
    };

    Array.from(state.layerStructure.values()).forEach(layer => {
        result.data.push({
            layer: layer,
            visibility: Boolean(state.layerVisibility.get(layer.guid)),
            settings: state.layerSettings.get(layer.guid),
        });
    });

    state.savedTemplates.push(result);
}

export function loadTemplate(template: MapTemplate) {
    clearLayers();
    template.data.forEach(newLayerData => {
        createLayer(newLayerData.layer);
        setLayerVisible(newLayerData.layer, newLayerData.visibility);
        if (newLayerData.settings !== undefined) {
            setLayerSettings(newLayerData.layer, newLayerData.settings);
        }
    });
}
